<app-header *ngIf="!oops" [item]="idComercio" (ecomerce)="validarecomerce( $event )">
</app-header>
<div *ngIf="!finalizar && !oops">
    <div class="containerS">
        <input class="inputSerch" type="text" (change)="buscarProductos()" id="buscadorHtml" placeholder="buscar...">
        <div class="search"></div>
    </div>
    <nav class="nav" style=" overflow-x: scroll; overflow-y: hidden;">
        <div class="row flex-row flex-nowrap mx-auto">
            <a *ngFor="let categoria of nuevasCategorias" (click)='cargaProductos(categoria.category_id)' class="nav-item">{{categoria.title}}</a>
            <span class="nav-indicator"></span>
        </div>
    </nav>

    <!-- <app-categories [categorias]="nuevasCategorias"></app-categories> -->
    <app-products (finalizarPedido)="cerrarCatalogo( $event )" [categoriaInput]="cateSelected" [idComercio]="idComercio" [salesCode]="salesCode" [etiquetasCom]="etiquetasCom" [ecomerce]="ecomerce" [nombre_tienda]="nuevasTiendas.ecommerce" [rnc]="rnc" [cedula]="cedula"></app-products>
</div>
<div *ngIf="finalizar" class="final animated fadeIn">
    <div class="card-columns">
        <div class="card-elm text-center" style="padding-top: 30pt !important;">
            <p>PEDIDO REGISTRADO CON ÉXITO</p>
        </div>
        <div class="card-elm">
            <img src="../../../assets/images/confirm.svg" style="height: 113px; width: 113px; align-self: center;" alt="...">
        </div>
        <div class="card-elm text-center">
            <blockquote class="blockquote mb-0">
                <small>*LA VENTANA SE CIERRA EN {{ totalTime }} SEGUNDOS</small>
            </blockquote>
        </div>
        <div class="card-elm">
            <button type="button" class="btn btn-otl-cerrar btn-block" (click)="cerrar()"><b>CERRAR</b></button>
        </div>

    </div>
</div>
<app-oops *ngIf="oops"></app-oops>
